import { render, staticRenderFns } from "./NavBarAdmin.vue?vue&type=template&id=c6257b84&scoped=true&"
import script from "./NavBarAdmin.vue?vue&type=script&lang=js&"
export * from "./NavBarAdmin.vue?vue&type=script&lang=js&"
import style0 from "./NavBarAdmin.vue?vue&type=style&index=0&id=c6257b84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6257b84",
  null
  
)

export default component.exports